module.exports = __webpack_public_path__ + "static/waves-b4cc2b10427ca8d4ddfc8288e7c54ccc.png";